// Split out of FigureLabelStep.tsx (react-refresh/only-export-components) —
// `validateSelections` is a pure function, not a component; the constants it
// depends on moved alongside it since FigureLabelStep.tsx also uses them
// directly (re-imported there). Behavior unchanged.

export interface FigureSelection {
  person_index: number;
  position_label: string;
  crop_data_url?: string;
}

export const MIN_FIGURES = 2;
export const MAX_FIGURES = 5;
export const MAX_LABEL_LEN = 10;

// ---------------------------------------------------------------------------
// Validation helpers
// ---------------------------------------------------------------------------

export function validateSelections(selections: FigureSelection[]): string | null {
  if (selections.length < MIN_FIGURES) {
    return `Select at least ${MIN_FIGURES} figures (currently ${selections.length}).`;
  }
  if (selections.length > MAX_FIGURES) {
    return `Select at most ${MAX_FIGURES} figures.`;
  }
  for (const s of selections) {
    if (!s.position_label.trim()) {
      return `Position label for Person ${s.person_index + 1} cannot be empty.`;
    }
    if (s.position_label.trim().length > MAX_LABEL_LEN) {
      return `Position label "${s.position_label}" is too long (max ${MAX_LABEL_LEN} characters).`;
    }
  }
  const labels = selections.map((s) => s.position_label.trim().toLowerCase());
  const unique = new Set(labels);
  if (unique.size !== labels.length) {
    return 'Position labels must be unique — each figure needs a distinct label.';
  }
  return null;
}
